/* eslint eqeqeq: 0*/
/* eslint no-mixed-operators: 0 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import TextField from 'material-ui/TextField';
import { Field, reduxForm } from 'redux-form';
import Checkbox from 'material-ui/Checkbox';
import styled from 'styled-components';
import { BODY_TEXT_COLOR, NEGATIVE_COLOR } from '../../config/colors'
import './style.css';
import AddressAutocompleteContainer from '../AddressAutocompleteContainer';
import * as modal from '../../reducers/modalReducer';
import { saveAddress, savePrimaryAddress } from '../../actions/address';
import * as addressReducer from '../../reducers/addressReducer';
import {getPickupAddresses} from '../../selectors/address';
import {checkIsCorrectDeliveryAddress, fetchAndUpdateDeliveryOptions} from '../../actions/api';
import RadioButtonChecked from 'material-ui/svg-icons/toggle/radio-button-checked';
import RadioButtonUnchecked from 'material-ui/svg-icons/toggle/radio-button-unchecked';
import {isDelivery} from '../../selectors/configSelectors';

const CONTAINER_HEIGHT = '100%';

const styles = {
    trashIconWrap: {"position":"absolute","right":"0","margin":"-3px 23px 0 0"},
    floatingText: {color: NEGATIVE_COLOR},
    textField: {fontSize: '16px', fontWeight:'400', color: BODY_TEXT_COLOR, width: 256 },
    underlineStyle: {borderColor: BODY_TEXT_COLOR},
    checkbox: {   },
    checkBoxLabel: { fontWeight: 400, fontSize: '16px', color: BODY_TEXT_COLOR },
    button: { width: '120px', fontWeight: 700 },
    editForm: {margin: '0'},
    trashIcon: {height:'25px', width:'25px', cursor: 'pointer'},
    trashIconColor: "red",
    labelStyle: { fontWeight: 700 },
    predictionsErrorStyle: { top: 4, bottom: 0, height: 0, fontSize: 12},
}
class AddAddressForm extends Component {
    floatingLabelStyle = {color: ['#',this.props.secondaryColor].join('')};
    floatingFocusLabelStyle = {color: ['#',this.props.secondaryColor].join('')};
    underlineFocusStyle = { borderColor: ['#',this.props.secondaryColor].join('')};
    fields = {
        'address': null,
        'note': null,
    };

    state = {
        isInputAddressActive: false,
        inputNameFocused: null,
        mainContainerHeight: CONTAINER_HEIGHT,
    };

    handleInputEnterPress = (e,  inputName, touched, error) => {
        if ((e.key === 'Enter' || e.key == '13') && error === undefined) {
            if (inputName === 'address') {
                e.preventDefault();
                if (this.state.address) {
                  console.log(this.state.address)
                  this.onInputBlur('address');
                  setTimeout(()=>{
                      this.fields['note'].focus();
                  },250);
              } else {
                console.log('no valid')
              }
            }  else if (inputName === 'note') {
                e.preventDefault();
                this.onInputBlur('note');
            }
        }
    };

    onInputFocus = (inputName) => {
      // mute
    };

    onInputBlur = (inputName) => {

    };

    renderNoteField = ({input, label, meta: {touched, error}, ...custom}) => (
        <TextField
            ref={(input) => {this.fields['note'] = input;}}
            type="text"
            onKeyPress={(e) => this.handleInputEnterPress(e, 'note', touched, error)}
            onFocus={()=>this.onInputFocus('note')}
            onBlur={()=>this.onInputBlur('note')}
            floatingLabelText={<span style={styles.floatingText}>Delivery Notes</span>}
            style={styles.textField}
            floatingLabelStyle={this.floatingLabelStyle}
            floatingLabelFocusStyle={this.floatingFocusLabelStyle}
            underlineStyle={styles.underlineStyle}
            underlineFocusStyle={this.underlineFocusStyle}
            errorText={(touched && error ? error : '')}
            textareaStyle={{marginTop:0}}
            {...input}
            {...custom}
        />
    );

  renderAddress = ({input, label, meta: {touched, error}, ...custom}) => (
    <div style={{width: '256px'}}>
      <AddressAutocompleteContainer
        onChange={this.handleAddressChange}
        onAddress={this.handleAddress}
        floatingLabelStyle={this.floatingLabelStyle}
        floatingLabelText={<span style={styles.floatingText}>Enter address</span>}
        underlineFocusStyle={this.underlineFocusStyle}
        inputStyle={styles.autoCompleteTextFieldStyle}
        location={this.props.pickupAddresses[0].address}
        radius={this.props.radius}
        allowedZipCodes={JSON.parse(this.props.allowedZipCodes)}
        forbiddenZipCodes={JSON.parse(this.props.forbiddenZipCodes)}
        checkIsCorrectDeliveryAddress={this.props.checkIsCorrectDeliveryAddress}
        predictionsErrorStyle={styles.predictionsErrorStyle}
      />
    </div>
  );

    renderCheckBox = (props) => (
        <Checkbox
          checked={props.input.value ? true : false}
          onCheck={props.input.onChange}

          checkedIcon={<RadioButtonChecked />}
          uncheckedIcon={<RadioButtonUnchecked />}

          iconStyle={{ fill: '#'+this.props.secondaryColor}}
          labelStyle={styles.checkBoxLabel}
          label="Set as Primary Address"
          labelPosition="left"
          style={styles.checkbox}
        />
    );

  onRemove = () => {
      this.props.onCloseRequest();
      this.props.onRemoveAddress();
  };

  handleAddressChange = () => {
    this.setState({
      pickupAddressIndex: null,
      deliveryAddressIndex: null,
    });
  };

  handleAddress = (addressObj) => {
    const newAddress = {...addressObj};
    this.setState({
      address: newAddress
    });
  };

  handleSubmit = () => {
    if (!this.state.address) return;
    let formValues = this.props.addressForm.AddAddressForm.values;
    if (!formValues) formValues = {};
    const addressInput = { ...this.state.address };
    delete formValues.address;
    const address = {
      ...formValues,
      ...addressInput,
      state: 'CA',
      country: 'USA'
    };
    this.props.saveAddress(address)
      .then(res=> {
        const data = res.data;
        this.props.addDeliveryAddress([{ address: data.address }]);
        if (address.isdefault) {
          const newAddressIndex = this.props.deliveryAddresses.length;
          this.props.setDelivery(newAddressIndex);
          this.props.primaryAddress({type: 'DELIVERY', addressId: res.data.address.id});
        }

      }).catch((err) => {

      });
      this.props.hideModal();
  }

  render() {
     const { isInputAddressActive, inputNameFocused } = this.state;
    return (
        <form name="editaddress" onSubmit={this.handleSubmit} style={styles.editForm}>

           {!this.state.isInputAddressActive &&
            <div>
                <HeaderTitle>Add Address</HeaderTitle>
                <HorLine />
            </div>
           }

            <FormWrapper style={{height: this.state.mainContainerHeight}}>

              {(!isInputAddressActive || inputNameFocused === 'address') &&
              <div>
                <Field
                  onFocus={() => this.onInputFocus('address')}
                  name="address"
                  component={this.renderAddress} />
              </div>
              }

                {!isInputAddressActive && this.props.deliveryAvailable &&
                    <CheckBoxWrapper>
                        <Field
                            name="isdefault"
                            component={this.renderCheckBox} />
                    </CheckBoxWrapper>
                }

                {(!isInputAddressActive || inputNameFocused === 'note') &&
                    <div>
                        <Field
                            onFocus={() => this.onInputFocus('note')}
                            name="comment"
                            component={this.renderNoteField} />
                    </div>
                }


            </FormWrapper>

            {!this.state.isInputAddressActive &&
                <ButtonsWrapperDiv>
                    <LeftDiv><ButtonDiv onClick={this.props.onCloseRequest}>Cancel</ButtonDiv></LeftDiv>
                    <RightDiv>
                      <ButtonDiv
                        onClick={this.handleSubmit}
                        color={`#` + this.props.secondaryColor}
                        disabled={!this.state.address}
                      >
                        Save
                      </ButtonDiv>
                    </RightDiv>
                </ButtonsWrapperDiv>
            }

        </form>
    );
  }
}

AddAddressForm = reduxForm({
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
  form: 'AddAddressForm',
})(AddAddressForm);

const mapStateToProps = (state) => {
  return {
    isPhone: state.config.isPhone,
    is_iPhone: state.config.is_iPhone,
    primaryColor: state.config.primaryColor,
    secondaryColor: state.config.secondaryColor,
    addressForm: state.form,
    deliveryAddresses: addressReducer.getDeliveryAddresses(state),
    pickupAddresses: getPickupAddresses(state),
    radius: state.config.ECOMMERCE_ADDRESS_RADIUS,
    allowedZipCodes: state.config.ALLOWED_ZIP_CODES,
    forbiddenZipCodes: state.config.FORBIDDEN_ZIP_CODES,
    deliveryAvailable: isDelivery(state)
  };    
};

const mapDispatchToProps = (dispatch) => {
  return {
    hideModal: () => dispatch(modal.hideModal()),
    saveAddress: (address) => saveAddress(address),
    addDeliveryAddress: (address) => dispatch(addressReducer.addDeliveryAddresses(address)),
    setDelivery: (addressIndex) => dispatch(addressReducer.setDelivery(addressIndex)),
    primaryAddress: (data) => dispatch(savePrimaryAddress(data)),
    updateDeliveryOptions: () => dispatch(fetchAndUpdateDeliveryOptions()),
    checkIsCorrectDeliveryAddress: (placeId) => dispatch(checkIsCorrectDeliveryAddress(placeId))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddAddressForm);

const HeaderTitle = styled.div `
  text-align: center;
  margin-top: 18px;
  font-size: 21px;
  font-weight: 800;
  font-family: 'Futura-Bold';
  color: ${BODY_TEXT_COLOR};
`
const CheckBoxWrapper = styled.div `
  width: 256px;
  margin-top: 14px;
`

const HorLine = styled.hr `
    display: block;
    height: 2px;
    border: 0;
    border-top: 2px solid #f4f4f4;
    margin: 1em 0 0;
    padding: 0;
`;

const FormWrapper = styled.div `
    display: flex;
    color: #515151;
    flex-direction: column;
    font-size: 18px;
    align-items: center;
    justify-content: center;
    margin: 0 0 30px 0;
    height: 100%;
    font-family: 'Roboto', sans-serif;
    font-weight: 400;
`;

const ButtonsWrapperDiv = styled.div `
  height: 50px;
  width: 100%;
  border-top: 1px solid #E6E6E7;
`;

const LeftDiv = styled.div `
    float:left;
    width: 50%;
    background-color: #fff;
    height: 100%;
    border-right: 1px solid #E6E6E7;
    box-sizing: border-box;
`;

const RightDiv = styled.div `
    float: right;
    background-color: #fff;
    height: 100%;
    width: 50%;
`;

const ButtonDiv = styled.div `
    cursor: pointer;
    display: flex;
    font-weight: 400;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    padding: 15px;
    color: ${props => {
      if (props.disabled) {
        return "#E6E6E7"
      } else if (props.color) {
        return props.color;
      } else {
        return '#616161';
      }
    }};
`;



// WEBPACK FOOTER //
// ./src/components/AddAddressForm/AddAddressForm.jsx